import CommonProcess from 'app/components/OrderPayment/Common/CommonProcess';
import React from 'react';

const EbanxPaymentMob = () => {
  return <CommonProcess />;
};

export default EbanxPaymentMob;
